import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts'

import '../styles/FaultsView.css'
import LoadingProgress from '../components/LoadingProgress'
import { fetchMatrixs } from '../actions/matrixs'
import { fetchMachines } from '../actions/machines'

const EXCLUDE_CUSTOMER_ID = '620d1664db950220fabc0a41' // VACWAY TECH

const STATUS_COLORS = {
  AVAILABLE:    '#2e7d32',
  LOW_BT:       '#0097a7',
  FAULT:        '#c62828',
  UNCONFIGURED: '#111827',
}

class LowBluetoothView extends React.Component {
  constructor(props) {
    super(props)
    this.state = { excludeVacway: true, topMetric: 'FB' }
    this.toggleExcludeVacway = this.toggleExcludeVacway.bind(this)
    this.setTopMetric = this.setTopMetric.bind(this)
  }

  componentDidMount() {
    this.props.fetchMatrixs('')
    this.props.fetchMachines()
  }

  toggleExcludeVacway() {
    this.setState({ excludeVacway: !this.state.excludeVacway })
  }

  setTopMetric(metric) {
    this.setState({ topMetric: metric })
  }

  getFilteredMatrixs() {
    const { matrixs, machines } = this.props
    if (!this.state.excludeVacway) return matrixs
    return matrixs.filter(matrix => {
      const machine = machines.find(m => m.Serial === matrix.Serial)
      return !machine || !machine.Customer || machine.Customer._id !== EXCLUDE_CUSTOMER_ID
    })
  }

  computeStats(filteredMatrixs) {
    let TOTAL = 0, AVAILABLE = 0, FAULT = 0, LOW_BT = 0, UNCONFIGURED = 0

    filteredMatrixs.forEach(matrix => {
      matrix.Locker.forEach(lock => {
        TOTAL++
        if (!lock.Configured) {
          UNCONFIGURED++
        } else {
          switch (lock.Status) {
            case 'AV':
            case 'BL':
            case 'RQ':
            case 'RK':
            case 'RM':
            case 'RP': AVAILABLE++; break  // operational (available, rental, occupied)
            case 'FL': FAULT++;    break
            case 'FB': LOW_BT++;   break
            default:   AVAILABLE++; break  // any other configured status = operational
          }
        }
      })
    })

    const TOTAL_ISSUES = FAULT + LOW_BT + UNCONFIGURED
    const PCT_OK = TOTAL > 0 ? ((AVAILABLE / TOTAL) * 100).toFixed(1) : '0.0'

    return { TOTAL, AVAILABLE, FAULT, LOW_BT, UNCONFIGURED, TOTAL_ISSUES, PCT_OK }
  }

  computeCustomerStats(filteredMatrixs) {
    const { machines } = this.props
    const byCustomer = {}

    filteredMatrixs.forEach(matrix => {
      const machine = machines.find(m => m.Serial === matrix.Serial)
      const customerName = machine && machine.Customer && machine.Customer.Fullname
        ? machine.Customer.Fullname : '—'

      if (!byCustomer[customerName]) {
        byCustomer[customerName] = { customer: customerName, FB: 0, FL: 0, UNCONFIGURED: 0 }
      }

      matrix.Locker.forEach(lock => {
        if (!lock.Configured) {
          byCustomer[customerName].UNCONFIGURED++
        } else {
          switch (lock.Status) {
            case 'FB': byCustomer[customerName].FB++; break
            case 'FL': byCustomer[customerName].FL++; break
            default: break
          }
        }
      })
    })

    return Object.values(byCustomer)
      .filter(r => r.FB > 0 || r.FL > 0 || r.UNCONFIGURED > 0)
      .sort((a, b) => a.customer.localeCompare(b.customer))
  }

  render() {
    const { matrixs, machines } = this.props
    const { excludeVacway, topMetric } = this.state

    if (!matrixs || !machines) {
      return <LoadingProgress />
    }

    const filteredMatrixs = this.getFilteredMatrixs()
    const { TOTAL, AVAILABLE, FAULT, LOW_BT, UNCONFIGURED, TOTAL_ISSUES, PCT_OK } = this.computeStats(filteredMatrixs)
    const customerStats = this.computeCustomerStats(filteredMatrixs)

    const pieData = [
      { name: 'Operativas',     value: AVAILABLE,    color: STATUS_COLORS.AVAILABLE },
      { name: 'Low BT (FB)',    value: LOW_BT,        color: STATUS_COLORS.LOW_BT },
      { name: 'Averías (FL)',   value: FAULT,         color: STATUS_COLORS.FAULT },
      { name: 'Sin configurar', value: UNCONFIGURED,  color: STATUS_COLORS.UNCONFIGURED },
    ].filter(d => d.value > 0)

    const renderPieLabel = ({ name, percent }) => `${(percent * 100).toFixed(1)}%`

    const TOP_METRICS = [
      { key: 'FB',           label: 'Low BT',     color: STATUS_COLORS.LOW_BT },
      { key: 'FL',           label: 'Averías',    color: STATUS_COLORS.FAULT },
      { key: 'UNCONFIGURED', label: 'Sin config.', color: STATUS_COLORS.UNCONFIGURED },
    ]
    const activeMetric = TOP_METRICS.find(m => m.key === topMetric)
    const top5 = [...customerStats]
      .sort((a, b) => b[topMetric] - a[topMetric])
      .slice(0, 5)
      .filter(r => r[topMetric] > 0)

    return (
      <div className="faults-view">

        <div className="faults-header">
          <div className="faults-title-section">
            <h1 className="faults-title">
              <i className="fas fa-wifi" />
              LOW BLUETOOTH
            </h1>
          </div>
          <div className="faults-actions">
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', margin: 0, fontSize: 13, fontWeight: 600, color: '#374151', whiteSpace: 'nowrap' }}>
              Excluir VACWAY
              <label className="switch" style={{ margin: 0 }}>
                <input type="checkbox" checked={excludeVacway} onChange={this.toggleExcludeVacway} />
                <span className="slider round" />
              </label>
            </label>
          </div>
        </div>

        <div className="faults-kpi-wrapper pb-3">
          <div className="faults-kpi-row">

            <div className="fault-kpi-card total">
              <div className="kpi-icon"><i className="fas fa-th" /></div>
              <div className="kpi-content">
                <div className="kpi-label">Total taquillas</div>
                <div className="kpi-value">{TOTAL}</div>
              </div>
            </div>

            <div className="fault-kpi-card green-block">
              <div className="kpi-icon"><i className="fas fa-check-circle" /></div>
              <div className="kpi-content">
                <div className="kpi-label">Operativas</div>
                <div className="kpi-value">
                  {AVAILABLE}&nbsp;<small style={{ fontSize: 13, fontWeight: 500, color: '#6b7280' }}>{PCT_OK}%</small>
                </div>
              </div>
            </div>

            <div className="fault-kpi-card broken">
              <div className="kpi-icon"><i className="fas fa-exclamation-triangle" /></div>
              <div className="kpi-content">
                <div className="kpi-label">Total incidencias</div>
                <div className="kpi-value">{TOTAL_ISSUES}</div>
              </div>
            </div>

            <div className="fault-kpi-card door-block">
              <div className="kpi-icon"><i className="fas fa-wifi" /></div>
              <div className="kpi-content">
                <div className="kpi-label">Low Bluetooth (FB)</div>
                <div className="kpi-value">{LOW_BT}</div>
              </div>
            </div>

            <div className="fault-kpi-card red-block">
              <div className="kpi-icon"><i className="fas fa-tools" /></div>
              <div className="kpi-content">
                <div className="kpi-label">Averías (FL)</div>
                <div className="kpi-value">{FAULT}</div>
              </div>
            </div>

            <div className="fault-kpi-card" style={{ borderLeft: '4px solid #111827' }}>
              <div className="kpi-icon" style={{ background: '#f1f5f9', color: '#111827' }}><i className="fas fa-question-circle" /></div>
              <div className="kpi-content">
                <div className="kpi-label">Sin configurar</div>
                <div className="kpi-value">{UNCONFIGURED}</div>
              </div>
            </div>

          </div>
        </div>

        {/* Chart + Top 5 */}
        <div className="faults-columns-row">

          {/* Donut chart */}
          <div className="fault-column">
            <div className="card-section" style={{ height: '100%' }}>
              <div className="card-header-custom">
                <i className="fas fa-chart-pie mr-2" />Distribución de estados
              </div>
              <div className="card-body-custom" style={{ display: 'flex', alignItems: 'center', gap: 0, padding: '16px 8px', flex: 1 }}>
                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                  <ResponsiveContainer width="100%" height={240}>
                    <PieChart>
                      <Pie
                        data={pieData}
                        dataKey="value"
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={95}
                        paddingAngle={2}
                        label={renderPieLabel}
                        labelLine={{ stroke: '#6b7280', strokeDasharray: '4 3', strokeWidth: 1 }}
                      >
                        {pieData.map((entry, i) => (
                          <Cell key={i} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip formatter={(value, name) => [`${value} (${TOTAL > 0 ? ((value / TOTAL) * 100).toFixed(1) : 0}%)`, name]} />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                <ul style={{ listStyle: 'none', margin: 0, padding: '0 16px 0 8px', flexShrink: 0, width: 180 }}>
                  {pieData.map((entry, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: i < pieData.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                      <span style={{ width: 10, height: 10, borderRadius: '50%', background: entry.color, flexShrink: 0 }} />
                      <span style={{ fontSize: 12, color: '#374151', fontWeight: 600, flex: 1 }}>{entry.name}</span>
                      <span style={{ fontSize: 13, fontWeight: 700, color: entry.color }}>{entry.value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Top 5 customers */}
          <div className="fault-column">
            <div className="card-section" style={{ height: '100%' }}>
              <div className="card-header-custom" style={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                <span><i className="fas fa-trophy mr-2" />Top 5 clientes</span>
                <div style={{ display: 'flex', gap: 4 }}>
                  {TOP_METRICS.map(m => (
                    <button
                      key={m.key}
                      onClick={() => this.setTopMetric(m.key)}
                      style={{
                        fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20, border: 'none', cursor: 'pointer',
                        background: topMetric === m.key ? m.color : 'rgba(255,255,255,0.15)',
                        color: '#fff',
                        boxShadow: topMetric === m.key ? `0 0 0 2px #fff` : 'none',
                        transition: 'all 0.15s'
                      }}
                    >{m.label}</button>
                  ))}
                </div>
              </div>
              <div className="card-body-custom" style={{ padding: 0 }}>
                {top5.length === 0
                  ? <p className="text-center text-muted py-3 mb-0">Sin datos</p>
                  : top5.map((row, i) => (
                    <div key={row.customer} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', borderBottom: i < top5.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                      <span style={{ fontSize: 18, fontWeight: 800, color: '#d1d5db', minWidth: 24, textAlign: 'center' }}>{i + 1}</span>
                      <div style={{ flex: 1, fontSize: 13, fontWeight: 600, color: '#111827' }}>{row.customer}</div>
                      <span className="badge" style={{ background: activeMetric.color, color: '#fff', fontSize: 14, padding: '4px 10px' }}>{row[topMetric]}</span>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>

        </div>

        {/* Customer report — full width */}
        <div className="card-section mt-2">
          <div className="card-header-custom">
            <i className="fas fa-users mr-2" />Incidencias por cliente
          </div>
          <div className="card-body-custom" style={{ padding: 0 }}>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th>Cliente</th>
                    <th className="text-center">Low BT</th>
                    <th className="text-center">Averías</th>
                    <th className="text-center">Sin config.</th>
                  </tr>
                </thead>
                <tbody>
                  {customerStats.length === 0
                    ? <tr><td colSpan={4} className="text-center text-muted py-3">Sin incidencias</td></tr>
                    : customerStats.map(row => (
                      <tr key={row.customer}>
                        <td><strong>{row.customer}</strong></td>
                        <td className="text-center">{row.FB > 0 ? <span className="badge" style={{ background: STATUS_COLORS.LOW_BT, color: '#fff' }}>{row.FB}</span> : '—'}</td>
                        <td className="text-center">{row.FL > 0 ? <span className="badge" style={{ background: STATUS_COLORS.FAULT, color: '#fff' }}>{row.FL}</span> : '—'}</td>
                        <td className="text-center">{row.UNCONFIGURED > 0 ? <span className="badge" style={{ background: STATUS_COLORS.UNCONFIGURED, color: '#fff' }}>{row.UNCONFIGURED}</span> : '—'}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  matrixs: state.matrixs.matrixs,
  machines: state.machines.machines,
  error: state.matrixs.error,
  loading: state.matrixs.loading,
  role: state.auth.role,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(LowBluetoothView)
